<template>
  <calm-page extra-class="branch" :title="$t('branch')">
    <template slot="actions">
      <calm-button variant="primary" @click="handleCreate()">
        <i class="fas fa-plus mr-1"></i> {{ $t("new") }}
      </calm-button>
    </template>

    <!-- ═══════════════ SEARCH BAR ═══════════════ -->
    <calm-filter-bar :hide-actions="true">
      <calm-field :label="$t('search')">
        <input
          v-model="searchQuery"
          type="text"
          class="ed"
          :placeholder="$t('search')"
        />
      </calm-field>
    </calm-filter-bar>

    <!-- ═══════════════ TABLE (skin the existing el-table, §11) ═══════════════ -->
    <calm-table
      :total="total"
      :from="from"
      :to="to"
      :per-page.sync="pagination.perPage"
      :current-page.sync="pagination.currentPage"
      :per-page-options="pagination.perPageOptions"
      :per-page-label="$t('per_page') !== 'per_page' ? $t('per_page') : 'ต่อหน้า'"
      :count-label="$t('data')"
      :to-label="$t('to')"
      :of-label="$t('of')"
      :empty-title="$t('no_data') !== 'no_data' ? $t('no_data') : 'ไม่พบข้อมูล'"
    >
      <el-table
        :data="queriedData"
        row-key="id"
        header-row-class-name="thead-light"
        @sort-change="sortChange"
        @selection-change="selectionChange"
      >
        <el-table-column
          v-for="column in tableColumns"
          :key="column.label"
          v-bind="column"
        >
        </el-table-column>

        <el-table-column
          min-width="200px"
          align="right"
          :label="$t('actions')"
        >
          <div slot-scope="{ $index, row }" class="branch__rowact">
            <calm-button
              variant="ghost"
              size="sm"
              icon-only
              @click="handleEdit($index, row)"
            >
              <i class="fas fa-pen"></i>
            </calm-button>
          </div>
        </el-table-column>
      </el-table>
    </calm-table>

    <!-- ═══════════════ ADD / EDIT MODAL ═══════════════ -->
    <calm-modal
      :show.sync="showAddModal"
      :title="$t('branch')"
      :show-footer="false"
    >
      <form class="branch__form" @submit.prevent="handleUpdate()">
        <base-input :label="$t('branch.name')" v-model="md.Name">
        </base-input>

        <base-input :label="$t('branch.code')" v-model="md.Code">
        </base-input>

        <input type="hidden" class="new-event--start" />
        <input type="hidden" class="new-event--end" />

        <div class="calm__modal__actions">
          <calm-button variant="ghost" @click="showAddModal = false">
            {{ $t("close") }}
          </calm-button>
          <calm-button variant="primary" native-type="submit">
            {{ $t("save") }}
          </calm-button>
        </div>
      </form>
    </calm-modal>
  </calm-page>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "./PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";

export default {
  mixins: [clientPaginationMixin],
  components: {
    BasePagination,
    RouteBreadCrumb,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  computed: {
    ...mapGetters({
      tableDataOrg: "Branch/getData",
    }),
    tableData: function () {
      // console.log(this.$route.query.id);
      // if (this.$route.query.id != null) {
      //   return this.tableDataOrg.filter((m) => {
      //     return m.EnterpriseID == "" + this.$route.query.id;
      //   });
      // }

      return this.tableDataOrg;
    },
    tableColumns: function () {
      return [
        {
          prop: "Name",
          label: this.$t("branch.name"),
          minWidth: 90,
          sortable: true,
        },
        {
          prop: "Code",
          label: this.$t("branch.code"),
          minWidth: 100,
          sortable: true,
        },
      ];
    },
  },
  data() {
    return {
      propsToSearch: ["Number", "Email"],
      selectedRows: [],
      showAddModal: false,
      md: {
        ID: "",
        Name: "",
        Code: "",
      },
    };
  },
  mounted() {
    this.listData();
  },
  methods: {
    ...mapActions({
      createData: "Branch/createData",
      updateData: "Branch/updateData",
      listData: "Branch/listData",
    }),
    handleCreate() {
      this.showAddModal = true;
      this.md.ID = 0;
      this.md.Name = "";
      this.md.Code = "";
    },
    handleEdit(index, row) {
      this.showAddModal = true;
      this.md.ID = row.ID;
      this.md.Name = row.Name;
      this.md.Code = row.Code;
    },
    handleUpdate() {
      this.showAddModal = false;

      if (this.md.ID == 0) {
        // create
        this.createData({
          name : this.md.Name,
          code : this.md.Code,
        })
          .then((resp) => {
            this.listData();
            swal.fire({
              title: this.$t("create_success"),
              text: ``,
              icon: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false,
            });
          })
          .catch((err) => {
            swal.fire({
              title: this.$t(err.response.data.Msg),
              text: this.getErrorText(err.response.data),
              icon: "error",
              confirmButtonClass: "btn btn-danger btn-fill",
              buttonsStyling: false,
            });
          });
      } else {
        // update
        this.updateData({
          id : this.md.ID,
          name : this.md.Name,
          code : this.md.Code,
        })
          .then((resp) => {
            this.listData();
            swal.fire({
              title: this.$t("edit_success"),
              text: ``,
              icon: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false,
            });
          })
          .catch((err) => {
            swal.fire({
              title: this.$t(err.response.data.Msg),
              text: this.getErrorText(err.response.data),
              icon: "error",
              confirmButtonClass: "btn btn-danger btn-fill",
              buttonsStyling: false,
            });
          });
      }
    },
    handleDelete(index, row) {
      swal
        .fire({
          title: this.$t("delete_confirm"),
          text: this.$t("delete_confirm_question") + row.Name,
          icon: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          confirmButtonText: this.$t("confirm"),
          cancelButtonText: this.$t("cancel"),
          buttonsStyling: false,
        })
        .then((result) => {
          if (result.value) {
            this.deleteData({
              id: row.ID,
            })
              .then((resp) => {
                this.listData();
                swal.fire({
                  title: this.$t("delete_success"),
                  text: ``,
                  icon: "success",
                  confirmButtonClass: "btn btn-success btn-fill",
                  buttonsStyling: false,
                });
              })
              .catch((err) => {
                swal.fire({
                  title: this.$t(err.response.data.Msg),
                  text: this.getErrorText(err.response.data),
                  icon: "error",
                  confirmButtonClass: "btn btn-danger btn-fill",
                  buttonsStyling: false,
                });
              });
          }
        });
    },
    selectionChange(selectedRows) {
      this.selectedRows = selectedRows;
    },
  },
};
</script>
<style scoped>
/* Branch CRUD — Calm skin. Namespaced under .branch so nothing leaks to other
   pages. The el-table is kept verbatim (§11 "skin, don't rewrite") and
   re-styled only via deep selectors below. */

/* Row-action cell: keep the single edit icon button right-aligned. */
.branch__rowact {
  display: inline-flex;
  gap: 6px;
  justify-content: flex-end;
}

/* Modal form: stacked inputs + action row spacing. */
.branch__form >>> .form-group {
  margin-bottom: 16px;
}
.branch__form .calm__modal__actions {
  margin-top: 8px;
}

/* The free-text search box reuses the Kit's .ed input look. */
.branch >>> .ed {
  width: 100%;
}

/* Skin the existing <el-table> so it reads as a Calm surface without
   touching any column definitions or slots (§11). Deep selectors only. */
.branch >>> .el-table {
  color: var(--c-text, #2c3e50);
  background: transparent;
}
.branch >>> .el-table th,
.branch >>> .el-table .thead-light th {
  background: var(--c-surface-soft, #f4f7fb);
  color: var(--c-text-soft, #5b6b7e);
  font-weight: 600;
  border-bottom: 1px solid var(--c-border, #e3e9f0);
}
.branch >>> .el-table td {
  border-bottom: 1px solid var(--c-border, #eef2f7);
}
.branch >>> .el-table::before {
  background: var(--c-border, #e3e9f0);
}
.branch >>> .el-table__row:hover > td {
  background: var(--c-surface-soft, #f7fafd) !important;
}
</style>
